(function () {
    var controllerId = 'host.views.insurers.insurerTeams.createEditInsurerTeamPage';
    var app = angular.module('app');
    app.controller(controllerId, [
        function () {
        }
    ]);
})();
